module.exports = __webpack_public_path__ + "img/storageLoc.b1f00139.png";